import { ArrowUpRight } from "lucide-react";
import { STACK_ROWS } from "./data";
import { Reveal } from "./Reveal";

export function Stack() {
  return (
    <section className="stack page-width" data-testid="stack-section">
      <div className="section-kicker">The toolbox</div>
      <div className="stack-row">
        <h2>
          Deep where it counts.
          <br />
          Broad when it helps.
        </h2>
        <div className="stack-list">
          {STACK_ROWS.map((row, i) => (
            <Reveal className="stack-item" delay={i * 0.07} key={row.area} data-testid={`stack-row-${i}`} y={14}>
              <span className="stack-index">0{i + 1}</span>
              <span className="stack-area">{row.area}</span>
              <span className="stack-items">{row.items}</span>
              <ArrowUpRight className="stack-arrow" size={16} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
